import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Button, Modal } from 'react-bootstrap';
import people from './peopleData'; // Replace './peopleData' with your actual data source

const People = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedPerson, setSelectedPerson] = useState(null);
  const peoplePerPage = 8; // 4x2 grid, so 8 people per page
  const [showModal, setShowModal] = useState(false);

  const filteredPeople = people.filter(
    (person) =>
      person.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      person.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastPerson = currentPage * peoplePerPage;
  const indexOfFirstPerson = indexOfLastPerson - peoplePerPage;
  const currentPeople = filteredPeople.slice(indexOfFirstPerson, indexOfLastPerson);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const openModal = (person) => {
    setSelectedPerson(person);
    setShowModal(true);
  };

  const closeModal = () => {
    setSelectedPerson(null);
    setShowModal(false);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, [currentPage]);

  return (
    <>
      <Card className="bottom-radius-15 text-light bg-black mb-4">
        <Card.Body>
          <Row className="mb-3">
            <Col>
              <h1 className="text-light">People</h1>
            </Col>
            <Col>
              <Form.Control
                type="text"
                placeholder="Search people by name or title"
                value={searchTerm}
                onChange={handleSearch}
                className="bg-dark-subtle shadow"
              />
            </Col>
          </Row>

          <Row xs={2} md={4} className="g-4">
            {currentPeople.map((person) => (
              <Col key={person.id}>
                <div onClick={() => openModal(person)}>
                  <Card className="bg-dark text-light radius-15">
                    {/* Image */}
                    <Card.Img
                      variant="top"
                      alt={person.name}
                      className="p-2 radius-15 cover people-img"
                      src={person.image}
                      style={{ height: '300px', objectFit: 'cover' }}
                    />
                    <Card.Body>
                      <Card.Title>{person.name}</Card.Title>
                      <Card.Text>{person.title}</Card.Text>
                    </Card.Body>
                  </Card>
                </div>
              </Col>
            ))}
          </Row>

          {/* Pagination */}
          <nav>
            <ul className="pagination justify-content-center">
              {Array(Math.ceil(filteredPeople.length / peoplePerPage))
                .fill()
                .map((_, index) => (
                  <li
                    key={index}
                    className={`page-item ${currentPage === index + 1 ? 'active' : ''
                      }`}
                  >
                    <Button onClick={() => paginate(index + 1)} className="page-link">
                      {index + 1}
                    </Button>
                  </li>
                ))}
            </ul>
          </nav>
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={closeModal} size="xl" dialogClassName="modal-dialog custom-modal">
        <Modal.Header closeButton>
        <Modal.Title className='d-block d-sm-none'>{selectedPerson && selectedPerson.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPerson && (
            <>
              <Row className="mb-3">
                <Col md={6} >
                  <img
                    src={selectedPerson.image}
                    alt={selectedPerson.name}
                    style={{ maxWidth: '100%', height: 'auto' }}
                    className='w-100 radius-15'
                  />
                </Col>
                <Col>
                  <Modal.Title className="d-none d-sm-block">{selectedPerson && selectedPerson.name}</Modal.Title>
                  <p>{selectedPerson.title}</p>
                  <p>{selectedPerson.summary}</p>
                  {selectedPerson.dob && <p><i class="bi bi-cake"></i> {selectedPerson.dob}</p>}
                  {selectedPerson.links && <div>{selectedPerson.links.map((link, index) => (
                    <a key={index} href={link.href} target="_blank" rel="noopener noreferrer" className="btn btn-secondary m-1">{link.text}</a>
                  ))}</div>}
                  {/* Add other details here */}
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        {/* Add Footer or additional content if needed */}
      </Modal>

      {/* Blur background */}
      {showModal && <div className="modal-backdrop blur" />}

    </>
  );
};

export default People;